import React from 'react';
interface SoundInIconProps extends React.SVGProps<SVGSVGElement> {
	fill?: string;
	width?: number;
	height?: number;
}

export function SoundInIcon({ width = 16, height = 16, fill = 'currentColor', ...props }: Readonly<SoundInIconProps>) {
	return (
		<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2489_22965)" fill={fill}>
				<path d="M13.89 4.092A.75.75 0 0115 4.75v14a.75.75 0 01-1.11.658L6.39 15.3H2.75a.75.75 0 01-.75-.75v-5.6l.004-.077A.75.75 0 012.75 8.2h3.64l7.5-4.108zM6.943 9.608a.751.751 0 01-.36.092H3.5v4.1h3.083a.75.75 0 01.36.093l6.557 3.59V6.017L6.943 9.608zM17.562 12.1c0-.827-.27-1.437-.534-1.839a2.955 2.955 0 00-.358-.448 1.89 1.89 0 00-.106-.1l-.023-.02a.75.75 0 01.914-1.19l-.156.205.156-.204h.001l.004.004.008.006.02.016a2.84 2.84 0 01.251.232c.152.154.35.38.544.677.392.598.779 1.489.779 2.66 0 1.178-.39 2.03-.8 2.593a3.714 3.714 0 01-.567.62 2.846 2.846 0 01-.289.22l-.008.005-.004.001-.002.002s-.005-.005-.392-.64l.39.64a.75.75 0 01-.781-1.279h-.001l.01-.008a2.2 2.2 0 00.432-.444c.246-.337.512-.886.512-1.71z" />
				<path d="M20.503 11.83c0-1.686-.51-2.785-.986-3.451a3.989 3.989 0 00-.65-.717 2.583 2.583 0 00-.242-.183h-.002l-.004-.003a.75.75 0 01.756-1.295l-.238.413.239-.413h.001l.002.002.004.003.012.005.03.02.1.066c.08.056.187.136.313.243.251.213.576.536.898.986.65.908 1.267 2.31 1.267 4.324 0 2.012-.615 3.484-1.247 4.461a6.64 6.64 0 01-.874 1.09 4.85 4.85 0 01-.302.278c-.038.032-.07.057-.094.075l-.029.024-.01.007-.004.003h-.002v.002a.75.75 0 01-.94-1.166l.059-.048.005-.004.048-.04c.047-.04.12-.103.21-.193a5.15 5.15 0 00.673-.842c.495-.765 1.007-1.959 1.007-3.647z" />
			</g>
			<defs>
				<clipPath id="clip0_2489_22965">
					<path fill={fill} d="M0 0H24V24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
